// extracted by mini-css-extract-plugin
export default {"errorMessage":"createProjectManager_errorMessage__hVZUd","inputError":"createProjectManager_inputError__jMdfK"};